import script from "./LtcsHrRequestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtcsHrRequestModal.vue?vue&type=script&setup=true&lang=ts"

import "./LtcsHrRequestModal.vue?vue&type=style&index=0&id=46274bc6&lang=scss"

const __exports__ = script;

export default __exports__